var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 142,
    viewBox: "0 0 28 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9996 76.5C28.4996 62.5 19.2325 52.1914 9.99937 39C3 29 -0.000396729 10.5 -0.000452042 0L0.000295639 142C0.000295639 120.5 5.50031 113 11.5003 105.5C17.5003 98 25.4996 90.5 26.9996 76.5Z",
    fill: "#E3F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeArrowRight);
export default __webpack_public_path__ + "static/media/shape_arrow_right.2a19c696f307751f2eee34482d3985f7.svg";
export { ForwardRef as ReactComponent };